import type { ButtonHTMLAttributes } from 'react'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  angular: boolean
}

/** 与 {@link ThemeModal} 标题栏关闭钮一致，供全屏层等非 ThemeModal 壳复用 */
export function ThemeModalCloseButton({ angular, className = '', ...rest }: Props) {
  return (
    <button
      type="button"
      className={[
        'shrink-0 border border-line bg-panel px-2.5 py-1.5 text-base font-semibold leading-none text-ink transition hover:bg-surface-muted',
        angular ? 'rounded-none' : 'rounded-lg',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-label="关闭"
      {...rest}
    >
      ✕
    </button>
  )
}
